<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<!--
Build EditIbansRequest
 -->
<template>
  <div>
    <div class="vx-row mb-2 w-full">
      <div class="vx-col w-full flex-inline">
        <vs-button
          style="float: left"
          @click="new_()"
          class="mx-0"
          color="dark"
          type="border"
          icon-pack="feather"
          icon="icon-plus"
          size="small"
          >جدید</vs-button
        >
      </div>
    </div>
    <vs-table id="tbl2" ref="tbl2" :data="items" class="table-dark-inverted">
      <template slot="thead">
        <vs-th>ردیف</vs-th>
        <vs-th sort-key="name">شبا</vs-th>
        <vs-th>حذف</vs-th>
        <vs-th>وضعیت</vs-th>
        <vs-th></vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <span>{{ indextr + 1 }}</span>
          </vs-td>
          <vs-td>
            <div
              class="vx-row flex-row-reverse"
              v-if="tr.type == 2 || tr.type == 0"
            >
              <div class="vx-col md:w-2/12 pt-3 px-1 f-5">- IR</div>
              <div class="vx-col md:w-10/12 pr-0">
                <vs-input
                  v-validate="'digits:24'"
                  placeholder="00000000000000000000000"
                  v-model="tr.iban"
                  name="defaultIban"
                  class="w-full mt-1 ltr-input"
                />
                <span class="text-danger text-sm"
                  >{{ errors.first("step-shop.defaultIban")
                  }}{{
                    errors.first("step-shop.defaultIban")
                      ? "(24-" + defaultIban.length + ")"
                      : ""
                  }}</span
                >
              </div>
            </div>
            <span
              v-else
              :class="{ 'line-through': tr.type == 3 }"
              :style="tr.isDefault ? { color: 'rgb(63 128 3)' } : {}"
              >IR {{ tr.iban }}</span
            >
          </vs-td>
          <vs-td>
            <feather-icon
              v-if="tr.type != 3"
              @click="remove(indextr)"
              strokeWidth="2"
              title="حذف"
              icon="XIcon"
              svgClasses="h-6 w-6 text-success"
            ></feather-icon>
            <feather-icon
              v-else
              @click="tr.type = 1"
              strokeWidth="2"
              title="بازگردانی"
              icon="RotateCwIcon"
              svgClasses="h-6 w-6 text-success"
            ></feather-icon>
          </vs-td>
          <vs-td>
            {{ EditIbanType[tr.type].title }}
          </vs-td>
          <vs-td>
            <feather-icon
              @click="defaultAction(tr)"
              strokeWidth="2"
              title="پیشفرض"
              icon="CheckCircleIcon"
              :svgClasses="
                'h-6 w-6 text-success ' + (tr.isDefault ? '' : ' opacity-25')
              "
            ></feather-icon>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="vx-col w-full flex" style="justify-content: center">
      <vs-button @click="cancel" class="my-3" color="primary" type="border"
        >انصراف</vs-button
      >
      <vs-button
        @click="save"
        class="my-3 mx-2"
        color="success"
        type="filled"
        icon-pack="feather"
        icon="icon-save"
        >ذخیره</vs-button
      >
    </div>
  </div>
</template>
<style>
</style>
<script>
import { EditIbanType, CreateEditMode } from "@/enums.js";
export default {
  name: "edit-iban",
  props: {},
  components: {
  },
  data() {
    return {
      items: [],
      merchantId: null,
      CreateEditMode,
      mode: CreateEditMode.Create,
      EditIbanType,
    };
  },
  methods: {
    show(merchantId, shopName = "") {
      this.items = [];
      if (merchantId) {
        this.merchantId = merchantId;
        this.getDate();
      }
    },
    async getDate() {
      let draftIbans = await this.getDraft();
      let ibans = await this.getMerchantIbans();
      if (this.mode == this.CreateEditMode.Create) {
        this.items = ibans.map((x) => {
          return {
            id: x.id,
            iban: x.iban.replace("IR", ""),
            type: 1,
            isDefault: x.isDefault,
          };
        });
      } else {
        this.items = draftIbans.map((x) => {
          return {
            iban: x.merchantIban.replace("IR", ""),
            type: x.type,
            isDefault: x.type == 0,
          };
        });
      }
    },
    async getDraft() {
      let items = [];
      let payload = {
        params: {
          id: this.merchantId,
        },
      };
      let loading = this.$vs.loading();
      await this.$http
        .get(`/api/services/app/draft/GetLastDraft`, payload)
        .then(async (response) => {
          this.draftRequest = response.data.result;
          if (
            this.draftRequest &&
            this.draftRequest.parentId &&
            this.draftRequest.step == 6 && //is edit iban
            ![8, 14].includes(this.draftRequest.state) //not approved and waiting
          ) {
            this.mode = this.CreateEditMode.Edit;
            items = this.draftRequest.draftMerchant.merchantIbans;
          } else {
            this.mode = this.CreateEditMode.Create;
          }
          this.popupActive = true;
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
      return items;
    },
    async getMerchantIbans() {
      let items = [];
      let loading = this.$vs.loading();
      await this.$http
        .get(`/api/services/app/Merchants/GetIbans?id=${this.merchantId}`)
        .then(async (response) => {
          items = response.data.result;
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
      return items;
    },
    defaultAction(tr) {
      switch (tr.type) {
        case 0:
          tr.type = 2;
          tr.isDefault = false;
          break;
        case 1:
          this.setAsDefault(tr);
          break;
        case 2:
          this.items.forEach((x) => {
            if (x.type == 0) {
              x.type = 2;
              x.isDefault = false;
            }
          });
          tr.type = 0;
          tr.isDefault = true;
          break;
      }
    },
    setAsDefault(tr) {
      let loading = this.$vs.loading();
      let payload = {
        id: tr.id,
      };
      this.$http
        .post("/api/services/app/Ibans/SetDefault", payload)
        .then((response) => {
          if (response.data.success == true) {
            this.items.forEach((x) => {
              if (x.type == 1 || x.type == 3) x.isDefault = false;
            });
            tr.isDefault = true;
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    new_() {
      this.items.push({ iban: "", type: 2, isDefault: false });
    },
    remove(i) {
      if (this.items[i].type == 2) this.items.splice(i, 1);
      else this.items[i].type = 3; //delete
    },
    save() {
      if (CreateEditMode.Create == this.mode) this.create();
      else this.update();
    },
    create() {
      let payload = {
        id: this.merchantId,
        NewIbans: [],
      };
      payload.NewIbans = this.items.map((x) => {
        return { iban: "IR" + x.iban, type: x.type };
      });
      // [
      //   ...this.items
      //     .filter((x) => x.isNew)
      //     .map((x) => {
      //       return { iban: "IR" + x.iban, type: 2 };
      //     }),
      //   ...this.items
      //     .filter((x) => x.deleteRequest)
      //     .map((x) => {
      //       return { iban: "IR" + x.iban, type: 3 };
      //     }),
      // ];
      let loading = this.$vs.loading();
      this.$http
        .post("/api/services/app/Shaparak/CreateEditIbanDraftRequest", payload)
        .then((response) => {
          if (response.data.success) {
            this.$emit("success");
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: `درخواست با موفقیت ذخیره شد.`,
            });
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    update() {
      let payload = {
        id: this.draftRequest.id,
        NewIbans: [],
      };
      payload.NewIbans = this.items.map((x) => {
        return { iban: "IR" + x.iban, type: x.type };
      });
      let loading = this.$vs.loading();
      this.$http
        .post("/api/services/app/draft/EditIbans", payload)
        .then((response) => {
          if (response.data.success == true) {
            this.$emit("success");
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: `درخواست با موفقیت ذخیره شد.`,
            });
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>
